import React, { useCallback, useRef } from "react";
import { List } from "../../Components/common/List/List.jsx";
import { ListProvider } from "../../Components/common/List/Providers/List.jsx";
import { createModalConfig } from "../../Models/ModalConfig.ts";
import { Modal, ModalBody } from "reactstrap";
import { useAddressBookIndexContext } from "./providers/index.ts";
import { useListProps } from "./utilities/list.tsx";
import AddressBookListItem from "./AddressBookListItem.tsx";
import { AddressBook } from "../../Models/AddressBook.ts";
import { AddressBookHandlerProvider } from "./providers/index.ts";
import { AddressBookHandler } from "./AddressBookHandler.tsx";
import { AddressBookDeleteProvider } from "./providers/AddressBookDeleteProvider.tsx";
import AddressBookDelete from "./AddressBookDelete.tsx";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const AddressBooks: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const listProps = useListProps();
  const {
    ownerId,
    service,
    registry,
    defaultValue,
    modalConfig,
    isBilling,
    setModalConfig,
  } = useAddressBookIndexContext();

  const renderItem = useCallback((item: AddressBook, index: number) => {
    return <AddressBookListItem listRef={listRef} item={item} index={index} />;
  }, []);

  const closeModal = () => {
    if (setModalConfig) {
      setModalConfig(createModalConfig());
    }
  };

  return (
    <>
      <AnyListProvider
        path={listProps.path}
        sorting={listProps.sorting}
        filters={listProps.filters}
      >
        <AnyList
          ref={listRef}
          title={listProps.title}
          create={listProps.create}
          banner={listProps.banner}
          massiveActions={listProps.massiveActions}
          renderItem={renderItem}
          pagination={listProps.pagination}
          selectRowsEnabled={listProps.selectRowsEnabled}
        />
      </AnyListProvider>

      <Modal isOpen={modalConfig?.isOpen} size={modalConfig?.size}>
        <ModalBody className={modalConfig?.className || ""}>
          {(modalConfig?.action === "create" ||
            modalConfig?.action === "edit") && (
            <>
              <h3 className="text-center">{modalConfig.title}</h3>
              <AddressBookHandlerProvider
                id={modalConfig?.data?.[0]}
                ownerId={ownerId}
                callback={() => {
                  closeModal();
                  listRef.current?.refresh();
                }}
                service={service}
                action={modalConfig?.action}
                registry={registry}
                defaultValue={defaultValue}
                isBilling={isBilling}
              >
                <AddressBookHandler />
              </AddressBookHandlerProvider>
            </>
          )}
          {modalConfig.action === "delete" && (
            <AddressBookDeleteProvider
              data={modalConfig.data}
              callback={() => {
                listRef.current?.refresh();
                closeModal();
              }}
              service={service}
            >
              <AddressBookDelete />
            </AddressBookDeleteProvider>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddressBooks;
